'use client';

import { useRouter } from 'next/navigation';
import { type PropsWithChildren, useEffect, useState } from 'react';
import { useSession } from 'next-auth/react';
import { PATHS } from '@/config/paths';
import { NavigationHandler } from '@/utils/navigation';

export const PublicAccessGuard = ({
  isVisible = true,
  isLoaded = false,
  children,
}: Readonly<PublicAccessGuardProps>) => {
  const router = useRouter();
  const { data: session } = useSession();

  const [loading, setLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);

  const navigationHandler = new NavigationHandler(router);

  useEffect(() => {
    if (isLoaded) {
      setShowContent(isVisible);

      setTimeout(() => {
        setLoading(false);
        if (!isVisible && (!session || !session.access_token)) {
          navigationHandler.navigate(PATHS.auth.login);
        }
      }, 1000);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded]);

  if (!showContent && !loading) {
    return <></>;
  }

  return <>{children}</>;
};

type PublicAccessGuardProps = PropsWithChildren<{
  isVisible?: boolean;
  isLoaded?: boolean;
}>;
